export const LIVING_HARBOR_STARTUP_TIMEOUT_MS = 30_000;
